import { useApi } from '~/composables/useApi';

const buildParams = (params: Record<string, string | number>) => {
  const body = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => body.append(k, String(v ?? '')));
  return body.toString();
};

export const useNoticeBoardApi = () => {
  const fetchPopNoticeList = (params: Record<string, string | number>) => {
    return useApi('/api/comPop/bsc/system/system/notice/popNoticeList_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: buildParams(params),
    });
  };

  const fetchPopNoticeDetail = (params: Record<string, string | number>) => {
    return useApi('/api/comPop/bsc/system/system/notice/popSelectNoticeDetail.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: buildParams(params),
    });
  };

  // 공지사항 상세 조회
  const fetchNoticeDetail = (params: Record<string, string | number>) => {
    return useApi('/api/bsc/system/system/notice/selectDetail.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: buildParams(params),
    });
  };

  return {
    fetchPopNoticeList,
    fetchPopNoticeDetail,
    fetchNoticeDetail,
  };
};
